import { render, staticRenderFns } from "./getWebinars.vue?vue&type=template&id=71bf7ed3"
import script from "./getWebinars.vue?vue&type=script&lang=js"
export * from "./getWebinars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports